export const repositoryFolderFunctions = {
    props: {
        moveUpLabel: {type: String, default: '..'},
        operationsUrl: {type: String},
        repository: {type: Object},
        startingPath: {type: Array, default: () => {return []}},
        searchedColumns: {type: Array, default: () => {return ['name', 'name_and_workflow_number', 'musicsheet_title']}},
        hiddenFolders: {type: Array, default: () => {return []}},
        hiddenFiles: {type: Array, default: () => {return []}}
    },
    data: function () {
        return {
            currentPath: [],
            sortingOption: '',
            sortingDirection: 'asc',
            searchText: '',
            folders: [],
            allFolders: [],
            watchPathChange: false,
            searchTextDebounce: null,
        }
    },
    methods: {
        initializePath: function() {
            if (this.currentPath.length == 0) {
                this.currentPath.push({
                    folder_id: null,
                    id: this.repository.fid,
                    name: this.repository.name,
                });
            }
            this.watchPathChange = true;
        },

        sortArrayBySortingOption: function(elements, sortingOptionCallable = null) {
            elements.sort((a, b) => {
                let aV = a[this.sortingOption];
                let bV = b[this.sortingOption];
                if (sortingOptionCallable) {
                    aV = sortingOptionCallable(aV);
                    bV = sortingOptionCallable(bV);
                }
                if (aV == bV) {
                    return 0;
                }
                return aV < bV
                    ? -1 * this.sortingDirectionValue
                    : this.sortingDirectionValue;

            });
            return elements;
        },
        setCurrentPathToFolder: function(folder) {
            let p = [];
            folder.path.forEach((pathItem) => {
                p.push(pathItem);
            });
            this.currentPath = p;
        },
        setCurrentPathToNode: function(nodeIndex) {
            while (this.currentPath.length > nodeIndex + 1) {
                this.currentPath.pop();
            }
        },
        moveUpOneFolder: function() {
            this.currentPath.pop();
        },
        selectNode: function(nodeIndex) {
            this.setCurrentPathToNode(nodeIndex)
        },

    },
    computed: {
        searchTextLowercase: function() {
            return this.searchText.trim().toLowerCase();
        },
        currentPathNodes: function() {
            let result = [];
            this.currentPath.forEach((node) => {

            });

            return result;
        },
        pathChecksum: function() {
            return this.currentPath.map(p => p.id).join('-');
        },
        sortingDirectionValue: function() {
            return this.sortingDirection == 'asc' ? -1 : 1;
        },
        sortedElements: function() {
            if ((this.viewMode) && (this.viewMode == 'list')) {
                return {
                    folders: this.folders,
                    files: this.files,
                }
            }
            let folders = []
            let files = [];
            let sortingOptionCallable = null;
            if (this.sortingOption == 'name') {
                sortingOptionCallable = (v) => {
                    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôőœṕŕßśșțùúüûǘűẃẍÿź·/_,:;'
                    const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuuwxyz------'
                    const p = new RegExp(a.split('').join('|'), 'g')
                    return v.toLowerCase()
                        .replace(p, c => b.charAt(a.indexOf(c)));
                };
            }
            if (this.sortingOption != '') {
                folders = this.sortArrayBySortingOption(this.folders, sortingOptionCallable);
                files = this.sortArrayBySortingOption(this.files, sortingOptionCallable);
            } else {
                folders = this.folders;
                files = this.files;
            }
            if (this.searchTextLowercase != '') {
                folders = folders.filter((f) => {
                    return f.name.toLowerCase().indexOf(this.searchTextLowercase) > -1;
                })
                files = files.filter((f) => {
                    for (let t = 0; t < this.searchedColumns.length; t++) {
                        if ((f[this.searchedColumns[t]])
                            && (f[this.searchedColumns[t]].toLowerCase().indexOf(this.searchTextLowercase) > -1)) {
                            return true;
                        }
                    }
                    return false;
                })
            }
            if (this.hiddenFolders.length > 0) {
                folders = folders.filter((f) => {
                    return !this.hiddenFolders.includes(f.id);
                })
            }
            if (this.hiddenFiles.length > 0) {
                files = files.filter((f) => {
                    return !this.hiddenFiles.includes(f.id);
                })
            }
            return {folders: folders, files: files};
        },
        repositorySlug: function() {
            return this.repository.slug;
        }
    },
    watch: {
        pathChecksum: function() {
            if (this.watchPathChange != false) {
                this.fetchElements();
            }
        },
        searchText: function() {
            if (this.showDetailSearchWindow) {
                return;
            }
            window.clearTimeout(this.searchTextDebounce);
            this.searchTextDebounce = window.setTimeout(() => {
                this.fetchElements();
            }, 500);
        }

    }
}